export const clientsListingRoutes = [
  {
    path: 'listing',
    name: 'client-listing',
    component: () => import(/* webpackChunkName: "clients-listing" */ './ClientsListing')
  },
  {
    path: 'create',
    name: 'create-client',
    component: () => import(/* webpackChunkName: "new-client" */ '../new-client/NewClient.vue')
  }
];
